<template>
  <div
    class="action-box"
    :tabindex="0"
    @keyup.enter="$emit('click')"
  >
    <div class="icon">
      <img
        class="default"
        :src="iconDefault"
        alt=""
      />
      <img
        class="hover"
        :src="iconHover"
        alt=""
      />
    </div>
    <span
      class="text mt-3"
      v-html="text"
    />
  </div>
</template>
<script>
export default {
  name: "action-box",
  props: {
    iconDefault: String,
    iconHover: String,
    text: String,
  },
};
</script>
